module.exports = __webpack_public_path__ + "static/media/pgd-upload.9fe2a606.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/pgd-upload.svg
// module id = 969
// module chunks = 0